import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../Login/AuthContext";

const Sidebar = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [role, setRole] = useState("");

  // Dropdown states
  const [employeeManagementDropdown, setEmployeeManagementDropdown] =
    useState(false);
  const [generateEmployeeDropdown, setGenerateEmployeeDropdown] =
    useState(false);
  const [postJobDropdown, setPostJobDropdown] = useState(false);

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole) {
      setRole(userRole || "");
    }
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const sidebarStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "250px",
    height: "100vh",
    background: "linear-gradient(135deg, #2c2c2c, #1a1a1a)",
    padding: "20px",
    flexDirection: "column",
    borderRight: "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "2px 0 10px rgba(0, 0, 0, 0.3)",
    zIndex: 1000,
    overflowY: "auto",
    display: "flex",
    justifyContent: "space-between",
  };

  const linkStyle = {
    textDecoration: "none",
    color: "white",
    padding: "10px",
    fontSize: "14px",
    borderRadius: "8px",
    marginBottom: "8px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "rgba(255, 255, 255, 0.1)",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
  };

  const dropdownStyle = {
    ...linkStyle,
    cursor: "pointer",
    justifyContent: "space-between",
  };

  const dropdownItemStyle = {
    ...linkStyle,
    marginLeft: "20px",
    marginBottom: "5px",
    background: "rgba(255, 255, 255, 0.05)",
    fontSize: "13px",
  };

  return (
    <div style={sidebarStyle}>
      <div>
        {role === "admin" ? (
          <>
            <h2
              style={{
                fontSize: "18px",
                marginBottom: "15px",
                color: "#fff",
                textAlign: "center",
              }}
            >
              Admin Panel
            </h2>

            <Link to="/dashboard" style={{ ...linkStyle, fontWeight: "bold" }}>
              <i className="fas fa-home"></i> Admin Dashboard
            </Link>

            {/* Regular admin links */}
            {[
              {
                path: "/dashboard/contact-data",
                label: "Contact Form Data",
                icon: "fas fa-envelope",
              },
              {
                path: "/dashboard/newsletter-data",
                label: "Newsletter Data",
                icon: "fas fa-newspaper",
              },
              {
                path: "/dashboard/post-blog",
                label: "Post Blog",
                icon: "fas fa-blog",
              },
            ].map((item, index) => (
              <Link key={index} to={item.path} style={linkStyle}>
                <i className={item.icon}></i> {item.label}
              </Link>
            ))}

            {/* Post Job Dropdown */}
            <div
              style={dropdownStyle}
              onClick={() => setPostJobDropdown(!postJobDropdown)}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <i className="fas fa-plus-circle"></i> Post Job
              </div>
              <i
                className={`fas fa-chevron-${postJobDropdown ? "up" : "down"}`}
              ></i>
            </div>

            {postJobDropdown && (
              <div style={{ marginBottom: "8px" }}>
                <Link to="/dashboard/post-job" style={dropdownItemStyle}>
                  <i className="fas fa-plus-circle"></i> Post Job
                </Link>
                <Link to="/dashboard/manage-jobs" style={dropdownItemStyle}>
                  <i className="fas fa-briefcase"></i> Manage Jobs
                </Link>
                <Link
                  to="/dashboard/check-job-applications"
                  style={dropdownItemStyle}
                >
                  <i className="fas fa-file-alt"></i> Manage Applications
                </Link>
              </div>
            )}

            {/* Generate Employee Dropdown */}
            <div
              style={dropdownStyle}
              onClick={() =>
                setGenerateEmployeeDropdown(!generateEmployeeDropdown)
              }
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <i className="fas fa-user-plus"></i> Generate HR
              </div>
              <i
                className={`fas fa-chevron-${
                  generateEmployeeDropdown ? "up" : "down"
                }`}
              ></i>
            </div>

            {generateEmployeeDropdown && (
              <div style={{ marginBottom: "8px" }}>
                <Link
                  to="/dashboard/generate-employee"
                  style={dropdownItemStyle}
                >
                  <i className="fas fa-user-plus"></i> Generate HR
                </Link>
                <Link to="/dashboard/getAllEmployee" style={dropdownItemStyle}>
                  <i className="fas fa-users"></i> HR Management
                </Link>
              </div>
            )}

            {/* Employee Management Dropdown */}
            <div
              style={dropdownStyle}
              onClick={() =>
                setEmployeeManagementDropdown(!employeeManagementDropdown)
              }
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <i className="fas fa-user-cog"></i> Employee Management
              </div>
              <i
                className={`fas fa-chevron-${
                  employeeManagementDropdown ? "up" : "down"
                }`}
              ></i>
            </div>

            {employeeManagementDropdown && (
              <div style={{ marginBottom: "8px" }}>
                <Link
                  to="/dashboard/employee-management"
                  style={dropdownItemStyle}
                >
                  <i className="fas fa-user-cog"></i> Employee Management
                </Link>
                <Link to="/admin/task-dashboard" style={dropdownItemStyle}>
                  <i className="fas fa-tasks"></i> Task Dashboard
                </Link>
                <Link to="/attendance-management" style={dropdownItemStyle}>
                  <i className="fas fa-calendar-check"></i> Attendance
                  Management
                </Link>
              </div>
            )}
          </>
        ) : (
          <Link to="/admin/task-dashboard" style={linkStyle}>
            <i className="fas fa-tasks"></i> Task Dashboard
          </Link>
        )}
      </div>

      {/* Logout Button */}
      <button
        onClick={handleLogout}
        style={{
          width: "100%",
          background: "#ff4d4d",
          color: "white",
          border: "none",
          cursor: "pointer",
          textAlign: "center",
          justifyContent: "center",
          padding: "10px",
          borderRadius: "8px",
          fontSize: "12px",
          transition: "background 0.3s ease",
        }}
        onMouseOver={(e) => (e.target.style.background = "#cc0000")}
        onMouseOut={(e) => (e.target.style.background = "#ff4d4d")}
      >
        <i className="fas fa-sign-out-alt"></i> Logout
      </button>
    </div>
  );
};

export default Sidebar;
